import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3af5cd0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ncgr-card ncgr-card--rounded-to-normal" }
const _hoisted_2 = { class: "ncgr-container ncgr-pad-t-24 ncgr-pad-b-24" }
const _hoisted_3 = { class: "ncgr-pad-b-16 details" }
const _hoisted_4 = { class: "table-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " アイテムの小計(税込) ", -1))
const _hoisted_6 = { class: "ncgr-typography-bold" }
const _hoisted_7 = { class: "table-row ncgr-mar-t-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 送料(税込) ", -1))
const _hoisted_9 = { class: "ncgr-typography-bold" }
const _hoisted_10 = {
  key: 0,
  class: "table-row ncgr-mar-t-4"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 決済手数料 ", -1))
const _hoisted_12 = { class: "ncgr-typography-bold" }
const _hoisted_13 = { class: "table-row ncgr-mar-t-16" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 合計(税込) ", -1))
const _hoisted_15 = { class: "ncgr-typography-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatPrice(_ctx.productPrice)), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatPrice(_ctx.shippingCost)), 1)
        ]),
        (_ctx.paymentFee > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatPrice(_ctx.paymentFee)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.formatPrice(_ctx.totalPrice)), 1)
      ])
    ])
  ]))
}